import { FeaturedArpMedia } from '@arpeggi/shared'
import { useInfiniteQuery, useMutation, useQuery, UseQueryOptions } from 'react-query'
import { queryClient } from '../../features/react-query-provider/ReactQueryClientProvider'
import {
  GetFeaturedMediaParams,
  getOneFeaturedMedia,
  useFeaturedMediaAPI
} from '../api/v2/FeaturedMediaAPI'
import { getNextPage, getPreviousPage } from './common'

export const useFeaturedMedia = ({
  arpMediaId,
  options
}: {
  arpMediaId: number
  options?: UseQueryOptions<FeaturedArpMedia>
}) => {
  return useQuery(['featured-media', arpMediaId], () => getOneFeaturedMedia(arpMediaId), options)
}

export const useFeaturedMedias = (params?: GetFeaturedMediaParams) => {
  const { getFeaturedMedia } = useFeaturedMediaAPI()

  return useInfiniteQuery(
    ['featured-medias'],
    ({ pageParam = params?.page || 1 }) => getFeaturedMedia({ ...params, page: pageParam }),
    {
      getPreviousPageParam: (firstPage) => getPreviousPage(firstPage),
      getNextPageParam: (lastPage) => getNextPage(lastPage)
    }
  )
}

export const useAddFeaturedMedia = () => {
  const { createFeaturedMedia } = useFeaturedMediaAPI()

  return useMutation(({ arpMediaId }: { arpMediaId: number }) => createFeaturedMedia(arpMediaId), {
    onSuccess: () => {
      queryClient.invalidateQueries(['featured-media'])
      queryClient.invalidateQueries(['featured-medias'])
      queryClient.invalidateQueries(['arp-media'])
      queryClient.invalidateQueries(['arp-medias'])
    }
  })
}

export const useDeleteFeaturedMedia = () => {
  const { deleteFeaturedMedia } = useFeaturedMediaAPI()

  return useMutation(({ arpMediaId }: { arpMediaId: number }) => deleteFeaturedMedia(arpMediaId), {
    onSuccess: () => {
      queryClient.invalidateQueries(['featured-media'])
      queryClient.invalidateQueries(['featured-medias'])
      queryClient.invalidateQueries(['arp-media'])
      queryClient.invalidateQueries(['arp-medias'])
    }
  })
}
